<template>
    <div class="selector">
        <span
            @click="
        toggleOpened();
        return false;
      "
            class="select-field"
        >{{ selectText }}</span>
        <div class="selector-select" v-if="selectOpened">
            <div class="selector-checkbox" v-for="item in items" :key="item.value">
                <input
                    @change="$emit('input', selected)"
                    type="checkbox"
                    :id="'cb-'+item.value"
                    :value="item.value"
                    v-model="selected"
                />
                <label :for="'cb-'+item.value">{{ item.text }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: Array, // {text, value}
        defaultText: String,
        value: Array
    },
    data() {
        return {
            selected: this.value,
            selectOpened: false,
        };
    },
    methods: {
        toggleOpened() {
            this.selectOpened = !this.selectOpened;
        },
        documentClick(e) {
            if (!this.$el.contains(e.target)){
                this.selectOpened = false
            }
        },
    },
    created() {
        window.addEventListener('click', this.documentClick)
    },
    destroyed() {
        window.removeEventListener('click', this.documentClick)

    },
    computed: {
        textMap() { return _.mapValues(_.keyBy(this.items, 'value'), 'text') },
        selectText() {
            const tm = this.textMap;
            if (this.selected.length == 0) {
                return this.defaultText;
            }
            if (this.selected.length == 1) {
                return tm[this.selected[0]];
            } else {
                return tm[this.selected[0]] + " + " + (this.selected.length - 1).toString();
            }
        }
    }
};
</script>
<style scoped lang="scss">
.select-field {
    background: white;
    display: block;
    border: 1px solid #aaa;
}
.selector {
    position: relative;
    cursor: pointer;
}
.selector-select {
    position: absolute;
    top: 53px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    width: 260px;
    z-index: 300;
    background: white;
    border: 1px solid #aaa;
    padding: 10px;
    label {
        margin-left: 7px;
    }
}
</style>
